import { render, staticRenderFns } from "./WhollyGuacamole.vue?vue&type=template&id=2065f91b&scoped=true&"
import script from "./WhollyGuacamole.vue?vue&type=script&lang=js&"
export * from "./WhollyGuacamole.vue?vue&type=script&lang=js&"
import style0 from "./WhollyGuacamole.vue?vue&type=style&index=0&id=2065f91b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065f91b",
  null
  
)

export default component.exports